export const KEYBUTTON = {
    'XEMCHITIET': 'xem-chi-tiet',
    'SUA': 'sua-thong-tin',
    'THEMMOI': 'them-moi',
    'DELETE': 'delete',
}

export const LOCAL_STORAGE = {
    ASSETS_MENU: 'assets_menu',
    ASSETS_PERMISSION_MENU: 'asssets_permission_menu'
}

// {label: '1. Sổ TD cấp GCN huấn luyện ATVSLĐ', url: '/bao-cao/so-theo-doi-cap-giay-chung-nhan-huan-luyen-atvs'},
// {label: '2. Sổ theo dõi cấp thẻ an toàn.', url: '/bao-cao/so-theo-doi-cap-the-an-toan'},
// {label: '3. Sổ TD nhóm 4 huấn luyện ATVSLĐ', url: '/bao-cao/so-theo-doi-nguoi-thuoc-nhom-4-duoc-huan-luyen-atvs'},
// {label: '4. Sổ TD huấn luyện an toàn hóa chất', url: '/bao-cao/so-theo-doi-huan-luyen-an-toan-hoa-chat'},
// {label: '5. Sổ TD huấn luyện PCCC & CNCH' , url: '/bao-cao/danh-sach-phong-chay-chua-chay-cuu-nan-cuu-ho'},
// {label: '6. Tổng TD huấn luyện các đối tượng', url: '/bao-cao/bao-cao-tong-danh-sach-huan-luyen-cac-doi-tuong'},
// {label: '7. DS học viên tham dự đào tạo', url: '/bao-cao/danh-sach-hoc-vien-tham-su-khoa-dao-tao'},
// {label: '8. DS khóa học thuê ngoài', url: '/bao-cao/danh-sach-khoa-hoc-thue-ngoai-theo-thoi-gian'},
// {label: '9. DS khóa học nội bộ', url: '/bao-cao/danh-sach-khoa-hoc-noi-bo-theo-thoi-gian'},
// {label: '10. Thống kê chương trình đào tạo', url: '/bao-cao/thong-ke-cac-chuong-trinh-dao-tao-theo-thoi-gian'},
// {label: '11. Tổng hợp QT đào tạo theo đối tượng', url: '/bao-cao/bao-cao-tong-hop-qua-trinh-dao-tao-theo-doi-tuong'},
// {label: '12.Lịch sử đào tạo theo nhân viên.', url: '/bao-cao/lich-su-dao-tao-theo-nhan-vien'},
// {label: '13. DS nhân viên chưa tham gia khóa ĐT', url: '/bao-cao/danh-sach-hoc-vien-chua-tham-gia-khoa-dao-tao'},
// {label: '14. DS khóa học hàng năm theo chức vụ', url: '/bao-cao/danh-sach-khoa-hoc-hang-nam-theo-to-chuc'},


export const KEYBAOCAO = {
    'BAO_CAO_SO_1': 'CourseBC1',
    'BAO_CAO_SO_2': 'CourseBC2',
    'BAO_CAO_SO_3': 'CourseBC3',
    'BAO_CAO_SO_4': 'CourseBC4',
    'BAO_CAO_SO_5': 'CourseBC5',
    'BAO_CAO_SO_6': 'CourseBC6',
    'BAO_CAO_SO_7': 'CourseBC7',
    'BAO_CAO_SO_8': 'Course',
    'BAO_CAO_SO_9': 'CourseBC9',
    'BAO_CAO_SO_10': 'TotalTrainingCourse',
    'BAO_CAO_SO_11': 'CourseBC11',
    'BAO_CAO_SO_12': 'CourseBC12',
    'BAO_CAO_SO_13': 'CourseBC13',
    'BAO_CAO_SO_14': 'CourseBC14',
}

export const KEYACTION = {
    ACTION_VIEW : 'ACTION_VIEW',
    ACTION_EDIT : 'ACTION_EDIT',
    ACTION_ADD : 'ACTION_ADD',
    ACTION_DELETE : 'ACTION_DELETE',
    ACTION_ULTILITY: 'ACTION_ULTILITY',
    ACTION_SEARCH: 'ACTION_SEARCH',
    ACTION_PRINT: 'ACTION_PRINT',
    ACTION_IMPORT: 'ACTION_IMPORT',
    ACTION_EXPORT: 'ACTION_EXPORT',
    ACTION_VIEW_DETAIL: 'ACTION_VIEW_DETAIL',
    ACTION_CUSTOM: 'ACTION_CUSTOM',
    ACTION_MULTI_DELETE: 'ACTION_MULTI_DELETE'
}

export const MENUROLE = {
    'BO_PHAN_TO_CHUC' : {
        function: 'scope:function:list:organizer',
        api: 'resource:api:organizer'
    },
    'NHOM_DOI_TUONG_HOC_VIEN' : {
        function: 'scope:function:list:trainee',
        api: 'resource:api:trainee'
    },
    'KHOA_HOC' : {
        function: 'scope:function:list:course',
        api: 'resource:api:course'
    },
    'LOP_HOC' : {
        function: 'scope:function:list:class',
        api: 'resource:api:class'
    },
    'HINH_THUC_DAO_TAO' : {
        function: 'scope:function:list:type',
        api: 'resource:api:type'
    },
    'QUAN_LY_DAO_TAO' : {
        function: 'scope:function:training:class-student',
        api: 'resource:api:class-student'
    },
    'BAO_CAO_1' : {
        function: 'scope:function:report:1',
        api: 'resource:api:report'
    },
    'BAO_CAO_2' : {
        function: 'scope:function:report:2',
        api: 'resource:api:report'
    },
    'BAO_CAO_3' : {
        function: 'scope:function:report:3',
        api: 'resource:api:report'
    },
    'BAO_CAO_4' : {
        function: 'scope:function:report:4',
        api: 'resource:api:report'
    },
    'BAO_CAO_5' : {
        function: 'scope:function:report:5',
        api: 'resource:api:report'
    },
    'BAO_CAO_6' : {
        function: 'scope:function:report:6',
        api: 'resource:api:report'
    },
    'BAO_CAO_7' : {
        function: 'scope:function:report:7',
        api: 'resource:api:report'
    },
    'BAO_CAO_8' : {
        function: 'scope:function:report:8',
        api: 'resource:api:report'
    },
    'BAO_CAO_9' : {
        function: 'scope:function:report:9',
        api: 'resource:api:report'
    },
    'BAO_CAO_10' : {
        function: 'scope:function:report:10',
        api: 'resource:api:report'
    },
    'BAO_CAO_11' : {
        function: 'scope:function:report:11',
        api: 'resource:api:report'
    },
    'BAO_CAO_12' : {
        function: 'scope:function:report:12',
        api: 'resource:api:report'
    },
    'BAO_CAO_13' : {
        function: 'scope:function:report:13',
        api: 'resource:api:report'
    },
    'BAO_CAO_14' : {
        function: 'scope:function:report:14',
        api: 'resource:api:report'
    },
    'QUAN_LY_NGUOI_DUNG' : {
        function: 'scope:function:user:user-manage',
        api: 'resource:api:user'
    },
}


